module.exports = __webpack_public_path__ + "static/media/sidebar_1.64f3ba80.png";